<template>
  <div class="task-page-wrap">
    <!-- 上方：今日任務 -->
    <div class="today-task-card">
      <div class="today-left">
        <div class="date-tag">{{ getTodayDateText() }}</div>
        <h1 class="today-title">{{ $t('studentProgramme.todayTask') }}</h1>
        <p class="today-sub" v-if="dailyTaskWorkId!=null">{{ $t('studentProgramme.todayTaskTip') }}</p>
        <p class="today-sub" style="color: #00d767;" v-if="dailyTaskWorkId==null">{{ $t('studentProgramme.todayTaskFinish') }}</p>
      </div>
      <!-- 右側浮動卡片 -->
      <div class="task-popup-card">
        <div class="popup-header">
          <div class="popup-icon">📝</div>
          <div>
            <div class="popup-title">{{ $t('studentProgramme.popupTitle') }}</div>
            <div class="popup-desc">{{ $t('studentProgramme.popupDesc') }}</div>
          </div>

        </div>
<!--        <div class="popup-stats-row">-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-icon">🔥</div>-->
<!--            <div class="stat-num">7</div>-->
<!--            <div class="stat-label">連續天數</div>-->
<!--          </div>-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-icon">🎯</div>-->
<!--            <div class="stat-num">80%</div>-->
<!--            <div class="stat-label">正確率</div>-->
<!--          </div>-->
<!--          <div class="stat-item">-->
<!--            <div class="stat-icon">🪙</div>-->
<!--            <div class="stat-num">+23</div>-->
<!--            <div class="stat-label">獲得金幣</div>-->
<!--          </div>-->
<!--        </div>-->
        <button class="start-btn" v-if="dailyTaskWorkId!=null" @click="toExamination">▶ {{ $t('studentProgramme.startQuiz') }}</button>
      </div>
    </div>

    <!-- 下方：過去任務歷史記錄 -->
    <div class="history-card">
      <div class="history-head">
        <div class="history-head-left">
          <span class="history-icon">⏱️</span>
          <div>
            <h2 class="history-title">{{ $t('studentProgramme.historyTitle') }}</h2>
            <p class="history-desc">{{ $t('studentProgramme.historyDesc') }}</p>
          </div>
        </div>
        <span class="history-badge" @click="getData">{{ $t('studentProgramme.refresh') }}</span>

      </div>
      <div class="history-list">
        <div class="history-item" v-for="(item, idx) in tableData" :key="idx">
          <div class="item-date">
            <div class="month">{{ splitYmd(item.startDate).month }}</div>
            <div class="day">{{ splitYmd(item.startDate).day }}</div>
          </div>
          <div class="item-info">
            <div class="item-name-row">
              <span class="item-name">{{ item.name }}</span>
              <span class="finished-tag" v-if="item.completedAt">✓ {{ $t('studentProgramme.todayTaskFinish') }}</span>
<!--              <span class="finished-tag" style="color: red;background-color: #e8e1e1" v-if="item.completedAt">x 未完成</span>-->
            </div>
<!--            <div class="item-sub">{{ item.totalQuantity }}道題目</div>-->
          </div>
          <div class="item-score">
            <span class="score-text">{{ $t('studentProgramme.score2') }}</span>
            <span class="score-num">{{ item.correctQuantity }}/{{ item.totalQuantity }}</span>
            <div class="progress-bar">
              <div class="progress-fill" :style="{width: item.correctQuantity/item.totalQuantity*100 + '%'}"></div>
            </div>
          </div>
          <div class="item-coin">
            <span style="display: inline-flex;
  align-items: center;
  justify-content: center;">
              <svg width="18" height="18" viewBox="-2 -2 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <circle cx="12" cy="12" r="11" fill="#F59E0B" stroke="#D97706" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="8" fill="#FCD34D" opacity="0.5" />
                  <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="800" fill="#92400E" font-family="Nunito,sans-serif">M</text>
                </g>
              </svg>
              {{ item.correctQuantity }}</span>
          </div>
          <div class="item-action">
            <span class="view-link"
                  v-if="needHomework(item)"
                  @click="toExamination2(item.id, 1)"
            >{{ $t("studentProgramme.doHomeWork") }} ›</span>
<!--            <span class="view-link"-->
<!--                  v-if="item.completedAt != null"-->
<!--                  @click="handleReview(item)"-->
<!--            >{{ $t("studentProgramme.review") }} ›</span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCountDailyTask, getHomeworks} from "@/api/homework";
import moment from "moment";
export default {
  data() {
    return {
      total: 0,
      tableData: [],
      listQ: {
        _page: 1,
        _limit: 30,
      },
      dailyTask:[],
      dailyTaskWorkId: null,
      dailyTaskGradeId: null,
      historyData: [
        {
          month: "10月",
          day: "12",
          taskName: "綜合數學任務",
          questionCount: 5,
          score: "4/5",
          percent: 80,
          progressColor: "#f59e0b",
          coin: "+23"
        },
        {
          month: "10月",
          day: "11",
          taskName: "綜合數學任務",
          questionCount: 5,
          score: "5/5",
          percent: 100,
          progressColor: "#22c55e",
          coin: "+31"
        },
        {
          month: "10月",
          day: "10",
          taskName: "綜合數學任務",
          questionCount: 5,
          score: "3/5",
          percent: 60,
          progressColor: "#f59e0b",
          coin: "+18"
        }
      ]
    }
  },
  created() {
    this.getCountDailyTask();
    this.getData();
  },
  methods: {
    getData() {
      let form = {
        studentId: null,
        gradeId: null,
        type: 2,
        startDate: null,
        endDate: null,
        keywords: null,
        name: null,
        _page: this.listQ._page - 1,
        _limit: this.listQ._limit,
      };
      getHomeworks(form).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    splitYmd(dateStr) {
      if (!dateStr) return { year: '', month: '', day: '' };
      const [y, m, d] = dateStr.split('-');
      const rawLocale = this.$i18n?.locale || 'zh_tc';
      const localeMap = {
        'zh_tc': 'zh-TW',
        'en': 'en'
      };
      const intlLocale = localeMap[rawLocale] ?? 'zh-TW';
      const dateObj = new Date(`${dateStr} 00:00:00`);

      if(rawLocale === 'en'){
        //英文：月份簡寫 Aug / Sep
        const monthName = new Intl.DateTimeFormat(intlLocale, {month:'short'}).format(dateObj);
        return {
          year: y,
          month: monthName,
          day: d
        };
      }else{
        //中文：08月
        return {
          year: y,
          month: `${m}月`,
          day: d
        };
      }
    },
    handleReview(row) {
      const answerResult = row.answerResult || {}
      this.$router.push({
        path: "/examinationAnswerResult",
        query: {
          objectName: row.number,
          type: "library",
          topicId: answerResult.topicId,
          id: answerResult.objectId,
          answerResultId: answerResult.id,
          questionListIds: answerResult.questionListIds,
          answerValues: answerResult.answerValues
        },
      });
    },
    toExamination2(id, gradeId) {
      this.$router.push({
        path: "/examination",
        query: {
          type: "work",
          id: id,
          gradeId: gradeId,
          startTime: moment().format("YYYY-MM-DD HH:mm:ss")
        },
      });
    },
    needHomework(row) {
      if (row.completedAt) return false;
      else if (row.startDate && row.endDate) {
        return this.$options.filters["isBetween2"](
            new Date(),
            row.startDate,
            row.endDate
        );
      } else if (!row.endDate) return true;
      else return false;
    },
    toExamination() {
      this.$router.push({
        path: "/examination",
        query: {
          type: "work",
          id: this.dailyTaskWorkId,
          gradeId: this.dailyTaskGradeId,
          startTime: moment().format("YYYY-MM-DD HH:mm:ss")
        },
      });
    },
    getTodayDateText() {
      try {
        let date = new Date();
        const rawLocale = this.$i18n?.locale || 'zh_tc';
        // 映射：專案key → Intl合法標籤
        const localeMap = {
          'zh_tc': 'zh-TW',
          'en': 'en'
        };
        const intlLocale = localeMap[rawLocale] ?? 'zh-TW';

        return new Intl.DateTimeFormat(intlLocale, {
          month: 'long',
          day: 'numeric',
          weekday: 'long'
        }).format(date);
      } catch (err) {
        let date = new Date();
        // 出錯兜底：繁體格式
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${m}/${d}`;
      }
    },
    // 将数据获取逻辑封装成一个方法
    async getCountDailyTask() {
      if (this.userInfo && this.userInfo.roleName === this.roleNameStudent) {
        getCountDailyTask().then((v) => {
          this.dailyTask=v.data;
          this.dailyTaskWorkId=this.dailyTask.id;
          this.dailyTaskGradeId=this.dailyTask.gradeId;
        });
      }
    },
  }
}
</script>

<style scoped>
.task-page-wrap {
  padding: 20px;
  /*background-color: #fff9ea;*/
  min-height: 100vh;
  box-sizing: border-box;
  max-width: 1024px;
  margin: 0 auto;
}

/* ========== 今日任務卡片 ========== */
.today-task-card {
  background: linear-gradient(135deg, #f2a940, #e69428);
  border-radius: 20px;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: 0 8px 24px rgba(242,169,64,0.25);
}
/* 背景裝飾幾何圖形 */
.today-task-card::before {
  content: "";
  position: absolute;
  top:20px; left: 240px;
  width:40px;height:40px;
  border:2px solid rgba(255,255,255,0.25);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
.today-task-card::after {
  content: "";
  position: absolute;
  bottom:30px; left:35%;
  font-size:80px;
  color:rgba(255,255,255,0.15);
  content:"%";
}

.today-left {
  margin-top: 20px;
  color:#fff;
  z-index: 2;
}
.date-tag {
  background: rgba(255,255,255,0.25);
  display: inline-block;
  padding: 6px 14px;
  border-radius: 99px;
  font-size:14px;
  margin-bottom:16px;
}
.today-title {
  font-size:44px;
  font-weight:bold;
  margin:0;
}
.today-sub {
  font-size:18px;
  opacity:0.9;
  margin: 8px 0 0;
}

/* 右側浮動任務彈卡 */
.task-popup-card {
  background:#fff;
  border-radius:18px;
  padding:24px;
  width:320px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.12);
  z-index: 2;
}
.popup-header {
  display:flex;
  gap:12px;
  align-items:flex-start;
  margin-bottom: 20px;
}
.popup-icon {
  width:40px;height:40px;
  background:#fff9c4;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:20px;
}
.popup-title {
  font-size:20px;
  font-weight:bold;
  color:#333;
}
.popup-desc {
  font-size:14px;
  color:#777;
  margin-top:4px;
}
.popup-stats-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 20px;
}
.stat-item {
  background: #fff8e8;
  border-radius:14px;
  padding:12px 6px;
  text-align:center;
}
.stat-icon {
  font-size:18px;
}
.stat-num {
  font-size:18px;
  font-weight:bold;
  color:#333;
  margin:4px 0;
}
.stat-label {
  font-size:12px;
  color:#888;
}
.start-btn {
  width:100%;
  padding:14px;
  border:none;
  background: linear-gradient(90deg,#e68a00,#f59e0b);
  color:white;
  border-radius:12px;
  font-size:18px;
  font-weight:bold;
  cursor:pointer;
}

/* ========== 過去任務歷史卡片 ========== */
.history-card {
  background:#ffffff;
  border-radius:20px;
  padding:28px;
  box-shadow:0 4px 16px rgba(0,0,0,0.06);
}
.history-head {
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:20px;
}
.history-head-left {
  display:flex;
  gap:12px;
  align-items:flex-start;
}
.history-icon {
  width:40px;height:40px;
  background:#fff9c4;
  border-radius:12px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:20px;
}
.history-title {
  font-size:22px;
  font-weight:bold;
  color:#333;
  margin:0;
}
.history-desc {
  color:#777;
  font-size:14px;
  margin:4px 0 0;
}
.history-badge {
  background:#fff2cc;
  color:#92400e;
  padding:6px 14px;
  border-radius:99px;
  font-size:14px;
  font-weight:500;
}

.history-list {
  border-top:1px solid #fff0cd;
}
.history-item {
  display: grid;
  grid-template-columns: 60px 1fr 180px 80px 80px;
  gap:16px;
  align-items:center;
  padding:18px 0;
  border-bottom:1px solid #fff0cd;
}
.item-date {
  width:54px;height:54px;
  background:#fff2cc;
  border-radius:12px;
  text-align:center;
  display:flex;
  flex-direction:column;
  justify-content:center;
  color:#92400e;
}
.item-date .month {
  font-size:12px;
}
.item-date .day {
  font-size:22px;
  font-weight:bold;
}
.item-name-row {
  display:flex;
  align-items:center;
  gap:8px;
}
.item-name {
  font-size:17px;
  font-weight:500;
}
.finished-tag {
  background:#dcfce7;
  color:#166534;
  padding:3px 8px;
  border-radius:6px;
  font-size:12px;
}
.item-sub {
  font-size:14px;
  color:#777;
  margin-top:4px;
}
.item-score {
  display:flex;
  flex-direction:column;
  gap:6px;
}
.score-text {
  font-size:13px;
  color:#888;
}
.score-num {
  color:#92400e;
  font-weight:bold;
  float:right;
}
.progress-bar {
  width:100%;
  height:8px;
  background:#f3f4f6;
  border-radius:99px;
  overflow:hidden;
}
.progress-fill {
  background: #f59e0b;
  height:100%;
  border-radius:99px;
}
.item-coin {
  font-weight:bold;
  color:#92400e;
}
.view-link {
  color:#92400e;
  cursor:pointer;
}

/* ========== 手機響應式斷點 ========== */
@media (max-width:768px) {
  .today-task-card {
    flex-direction:column;
    gap:24px;
  }
  .task-popup-card {
    width:100%;
  }
  .history-item {
    grid-template-columns: 50px 1fr;
    grid-template-rows: auto auto auto;
  }
  .item-score {
    grid-column: 1 / -1;
  }
  .item-coin {
    grid-column: 1;
  }
  .item-action {
    grid-column:2;
    text-align:right;
  }
  .today-title {
    font-size:34px;
  }
}
</style>
<style>
html, body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  /*background-color: #fff9ea;*/
}
</style>